import React, { useCallback, useEffect } from "react";
import { useMap, useMapEvents } from "react-leaflet";
import { useSetRecoilState } from "recoil";
import { mapBoundsAtom } from "../recoilBox";

const MapBoundsObserver: React.FC = () => {
  const map = useMap();
  const setMapBounds = useSetRecoilState(mapBoundsAtom);

  const updateBoundingBox = useCallback(() => {
    const bounds = map.getBounds();
    setMapBounds(bounds);
  }, [map, setMapBounds]);

  useMapEvents({
    moveend: updateBoundingBox,
    zoomend: updateBoundingBox,
  });

  useEffect(() => {
    updateBoundingBox();
  }, [updateBoundingBox]);

  return null;
};

export default MapBoundsObserver;
